import Vue from 'vue'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { sleep } from '@/utils/helpers'

export default Vue.extend({
  data() {
    return {
      currentIsLoginWith24Hours: this.$store.getters['Search/isLoginWith24Hours'],
      currentIsNewFace: this.$store.getters['Search/isNewFace'],
      currentIsProfImage: this.$store.getters['Search/isProfImage'],
      isSearchReseting: false
    }
  },
  computed: {
    ...mapGetters('Search', [
      'ageRadio1',
      'ageRadio2',
      'allFukens',
      'fukenCheckes',
      'jobRadio',
      'typeRadio',
      'charmRadio',
      'shutubotuRadio',
      'sortRadio',
      'jobs',
      'types',
      'charms',
      'isLoginWith24Hours',
      'isNewFace',
      'isProfImage'
    ]),
    ...mapGetters('Profile', ['initializedProfile', 'shutubotus']),

    /**
     * 検索項目を設定中
     */
    $_isSettingSearch(this: any): boolean {
      if (
        !this.allFukens ||
        this.ageRadio1 > 0 ||
        this.ageRadio2 > 0 ||
        this.jobRadio > 0 ||
        this.typeRadio > 0 ||
        this.charmRadio > 0 ||
        this.shutubotuRadio > 0 ||
        this.sortRadio > 0 ||
        this.isLoginWith24Hours > 0 ||
        this.isNewFace > 0 ||
        this.isProfImage > 0
      ) {
        return true
      }
      return false
    }
  },
  methods: {
    ...mapActions('Profile', ['getProfileItems']),
    ...mapMutations('Search', [
      'setAgeRadio1',
      'setAgeRadio2',
      'setAllFukens',
      'clearFukenCheckes',
      'setJobRadio',
      'setTypeRadio',
      'setCharmRadio',
      'setShutubotuRadio',
      'setSortRadio',
      'setIsLoginWith24Hours',
      'setIsNewFace',
      'setIsProfImage',
      'setJobs',
      'setTypes',
      'setCharms'
    ]),

    /**
     * 検索項目をリセットする
     */
    async $_resetSearchItem(this: any) {
      this.isSearchReseting = true
      this.setAgeRadio1(0)
      this.setAgeRadio2(0)
      this.setAllFukens(true)
      this.clearFukenCheckes()
      this.setJobRadio(0)
      this.setTypeRadio(0)
      this.setCharmRadio(0)
      this.setShutubotuRadio(0)
      this.setSortRadio(0)
      this.setIsLoginWith24Hours(0)
      this.setIsNewFace(0)
      this.setIsProfImage(0)
      this.currentIsLoginWith24Hours = 0
      this.currentIsNewFace = 0
      this.currentIsProfImage = 0
      await sleep(300)
      this.isSearchReseting = false
    }
  }
})
